import { useCallback, useMemo } from "react";
import { useForm } from "react-hook-form";

import { deleteWorkflowStep } from "../../../../services/apiWorkflows";
import useMutate from "../../../../hooks/useMutate";
import {
  getDefaultTargetWorkflowStepId,
  getRemoveStepPayload,
  getTargetWorkflowStepOptions,
} from "../utils/workflowAdminUtils";

export function useRemoveWorkflowStep({
  currentStep,
  fields,
  close,
  setShowRemoveSteps,
}) {
  const formMethods = useForm({
    defaultValues: {
      targetStep: getDefaultTargetWorkflowStepId(fields, currentStep),
    },
  });
  const { handleSubmit, watch } = formMethods;

  const { mutate: deleteWorkflowMutate } = useMutate(
    deleteWorkflowStep,
    ["adminWorkflow", "boards"],
    () => {},
    () => {
      close(false);
    }
  );

  const handleClose = useCallback(() => {
    setShowRemoveSteps(false);
  }, [setShowRemoveSteps]);

  const targetOptions = useMemo(
    () => getTargetWorkflowStepOptions(fields, currentStep),
    [currentStep, fields]
  );

  const handleRemoveWorkflowStep = useCallback(
    (data) => {
      const payload = getRemoveStepPayload(fields, currentStep, data.targetStep);

      if (payload) {
        deleteWorkflowMutate(payload);
      }
    },
    [currentStep, deleteWorkflowMutate, fields]
  );

  return {
    ...formMethods,
    handleSubmit,
    watch,
    handleClose,
    handleRemoveWorkflowStep,
    targetOptions,
    defaultTargetStepId: getDefaultTargetWorkflowStepId(fields, currentStep),
  };
}
